export default function HrReports() {
    return (
      <div className="p-6 bg-white rounded-xl shadow space-y-6">
        <h1 className="text-3xl font-bold text-gray-700">Reports</h1>
        <p className="text-gray-500">Generate HR reports for payroll, attendance, and leaves.</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <div className="bg-blue-500 text-white p-6 rounded-xl shadow hover:scale-105 transform transition cursor-pointer">
            <h2 className="text-xl font-semibold">Attendance Report</h2>
          </div>
          <div className="bg-green-500 text-white p-6 rounded-xl shadow hover:scale-105 transform transition cursor-pointer">
            <h2 className="text-xl font-semibold">Payroll Report</h2>
          </div>
          <div className="bg-purple-500 text-white p-6 rounded-xl shadow hover:scale-105 transform transition cursor-pointer">
            <h2 className="text-xl font-semibold">Leave Report</h2>
          </div>
          <div className="bg-yellow-500 text-white p-6 rounded-xl shadow hover:scale-105 transform transition cursor-pointer">
            <h2 className="text-xl font-semibold">Custom Reports</h2>
          </div>
        </div>
      </div>
    );
  }
  